import { FormField } from '../FormField';
import { Dropdown } from '../Dropdown/dropdown/Dropdown';
import { Toggle } from '../Toggle';
export const formElements = {
    field: FormField,
    dropdown: Dropdown,
    checkbox: Toggle,
    radio: Toggle,
    checkboxGroup: Toggle,
};
